import Spinner from '../global/Spinner'
import LotImageViewerScreen from '../../screens/LotImageViewerScreen'
import React, { useEffect, useState } from 'react'
import { showingSegmentationModal } from '../../store/ui/reducers'
import { connect } from 'react-redux'
import { getImpersonatedBy, getIsAdmin, getIsLogged } from '../../store/login/reducers'
import { getUnit } from '../../store/profile-configuration/reducers'
import { withRouter } from 'react-router-dom'
import { fetchLots, fetchLotsImages } from '../../store/lots/actions'
import {
    getCurrentProductLots,
    getFetchingLots,
    getFetchingLotsImages,
    getLots,
    getLotsImages
} from '../../store/lots/reducers'
import { getIsLoading } from '../../store/lots/reducers'
import { fetchProduct } from '../../store/products/actions'
import { setLastSelectedProduct } from '../../store/selected-objects/actions'
import { byProductId } from '../../store/products/reducers'
import LotImageViewer from '../lot-image-viewer/LotImageViewer'
import { goBack } from 'react-router-redux'
import { calcLotsDimensions, mapCurrentProductLots } from '../lots/utils'
import Typography from '../design-system/foundations/typography/Typography'
import Translation from '../global/Translation'
import Button from '../design-system/basics/button/Button'
import { getLastSelectedProduct } from '../../store/selected-objects/reducers'

const ProductLotsViewer = (props) => {

    const [fetchingLots, setFetchingLots] = useState('NONE')

    useEffect(() => {
        setFetchingLots('FETCHING');
        props.fetchProduct(props.productId, props.centerId).then((result) => {
            props.setLastSelectedProduct(result.product)
        })
        props.fetchLots(props.productId, props.centerId, props.outlet)
    }, [])

    useEffect(() => {
        if (!props.fetchingLots && !props.fetchingLotsImages && fetchingLots === 'FETCHING') {
            setFetchingLots('FETCHED');
            storeCurrentLots()
        }
    }, [props.fetchingLots, props.fetchingLotsImages, fetchingLots])

    const storeCurrentLots = () => {
        calcLotsDimensions(props.lots)
        const productLots = mapCurrentProductLots(props.lots, props.lotsImages, props.lastSelectedProduct.imgLarge)

        props.setCurrentProductLots(productLots)
    }

    return (
        <div style={{position: 'relative'}}>
            {fetchingLots !== 'FETCHED' ? <Spinner isLoading={true}/> :
                props.lots.length > 0 ? <LotImageViewerScreen {...props} />
                :
                <div style={{
                    position: 'absolute',
                    top: '128px',
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexFlow: 'column wrap'
                }}>
                    <Typography typeface="title-m-medium" neutral-900>
                        <Translation id="selected_material_not_available" defaultMessage="The selected material is not available at this time."/>
                    </Typography>
                    <Typography typeface="title-s-regular" neutral-600
                                style={{
                                    marginTop:'8px',
                                    marginBottom:'32px',
                                    maxWidth: '512px',
                                    textAlign: 'center'
                                }}
                    >
                        <Translation id="try_another_finish_or_thickness" defaultMessage="Try another finish or thickness of the same material, or select a different material from our catalog."/>
                    </Typography>
                    <Button size-m
                            style-black
                            onClick={props.goBack}
                            img="arrow_short"
                            hImg="arrow_large"
                    >
                        <Translation id="see_other_material_options" defaultMessage="See other material options"/>
                    </Button>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state, { productId, match }) => {
    return {
        isLogged: getIsLogged(state),
        isAdmin: getIsAdmin(state),
        impersonatedBy: getImpersonatedBy(state),
        parentUrl: match.params.parentUrl,
        productId: match.params.productId,
        centerId: match.params.center,
        outlet: match.params.outlet,
        unit: getUnit(state),
        showSegmentation: showingSegmentationModal(state),
        lots: getLots(state),
        lotsImages: getLotsImages(state),
        isLoading: getIsLoading(state),
        lastSelectedProduct: getLastSelectedProduct(state),
        fetchingLots: getFetchingLots(state),
        fetchingLotsImages: getFetchingLotsImages(state),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchLots: (productId, centerId, outlet, callback=null) => dispatch(fetchLots(productId, null, null, null, null, outlet, callback, centerId)),
        setCurrentProductLots: productLots => dispatch({ type: 'SET_CURRENT_PRODUCT_LOTS', productLots}),
        fetchProduct: (productId, centerId) => dispatch(fetchProduct(productId, null, centerId)),
        setLastSelectedProduct: product => {
            dispatch(setLastSelectedProduct(product))
        },
        goBack: () => {dispatch(goBack())},
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductLotsViewer))
